import { Payout } from 'services/api/entities';
import getPayoutAmount from './helpers';
import { WithdrawButton } from './components';
import { StyledContainer, StyledPayoutAmount } from './styled';

interface PropsType {
  onPayoutSuccess: () => void;
  payout: Payout;
}

const PayoutAmount = ({ payout, onPayoutSuccess }: PropsType) => (
  <StyledContainer>
    <StyledPayoutAmount variant="h3">
      {getPayoutAmount(payout)}
    </StyledPayoutAmount>

    <WithdrawButton onPayoutSuccess={onPayoutSuccess} payout={payout} />
  </StyledContainer>
);

export default PayoutAmount;
